export default "__VITE_ASSET__c51c5fa6__"